import type { ParamMatcher } from "@sveltejs/kit";

// Prevent random junk from being matched as community ids
export const match: ParamMatcher = (param) => {
  return /[a-zA-Z0-9-_]/.test(param);
};
